export default __webpack_public_path__ + "e9d57c62cc1ea344e515a3de97a55e78.svg";